const zoomInIcon = 'tc-icon-zoom_in';
const connectionIcon = 'tc-icon-question_answer';
const userPlusIcon = 'tc-icon-person_add';
const userDriveIcon = 'tc-icon-insert-drive-file';
const supervisorIcon = 'tc-icon-supervisor_account';
const connectWithPartners = 'connect-with-partners';
const findNewAgents = 'find-new-agents';
const sendRates = 'send-rates';
const recRates = 'receive-rates';
const findNewSuppliers = 'find-new-suppliers';
const findNewBuyers = 'find-new-buyers';
const tryOutForClient = 'try-out-for-client';
const findNewAgentsText = 'Find New Agents/Buyers';
const findNewSuppliersText = 'Find New Suppliers';
const findNewClientsText = 'Find New Clients';

const connectInfo = {
  leftIcon: connectionIcon,
  creationReason: connectWithPartners,
  title: 'Connect With My Current Partners',
  desc: [
    '- I want to make it easier to keep in touch with my industry partners.',
    '- One of my partners sent me a connection request.',
  ],
};

export const accomInfo = [
  {
    leftIcon: zoomInIcon,
    creationReason: findNewAgents,
    title: findNewAgentsText,
    desc: [
      "- I'm looking to find new agents/buyers to sell my products.",
    ],
  },
  {
    leftIcon: userDriveIcon,
    creationReason: sendRates,
    title: 'Send Rates To My Partners',
    desc: [
      '- I was asked to send my rates to a partner using TourConnect.',
      '- I want to make it easier to manage the process of sending out my rates each year.',
    ],
  },
  connectInfo,
];

export const buyerInfo = [
  {
    leftIcon: zoomInIcon,
    creationReason: findNewSuppliers,
    title: findNewSuppliersText,
    desc: [
      "- I'm looking to find new hotels and tours that we can offer to our clients.",
    ],
  },
  {
    leftIcon: userPlusIcon,
    creationReason: findNewBuyers,
    title: findNewAgentsText,
    desc: [
      "- I'm looking to find new agents/buyers to sell my product to their clients.",
    ],
  },
  {
    leftIcon: userDriveIcon,
    creationReason: recRates,
    title: 'Receive Rates From My Suppliers',
    desc: [
      '- One of my suppliers sent me their rates via TourConnect.',
      "- I want to receive my suppliers' rates in a standardized format and to never have to manually load rates again.",
    ],
  },
  connectInfo,
];

export const dmoInfo = [
  {
    leftIcon: zoomInIcon,
    creationReason: findNewAgents,
    title: findNewAgentsText,
    desc: [
      "- I'm looking to find new agents/buyers that may want to send travelers to our country/city/region.",
    ],
  },
  {
    leftIcon: connectionIcon,
    creationReason: connectWithPartners,
    title: 'Connect With Suppliers In Our Destination',
    desc: [
      '- I want to stay connected with the accommodation and experience providers in our country/city/region so we can promote them to the world.',
      '- One of my partners sent me a connection request.',
    ],
  },
];

const tryOutTCForClient = {
  leftIcon: supervisorIcon,
  creationReason: tryOutForClient,
  title: 'Try Out TourConnect For A Client',
  desc: [
    '- I want to see how TourConnect can help my clients.',
  ],
};

export const marketingRep = [
  tryOutTCForClient,
  {
    leftIcon: zoomInIcon,
    creationReason: findNewAgents,
    title: findNewClientsText,
    desc: [
      '- I want to find new clients that we can provide sales/marketing representation services to.',
    ],
  },
];

export const publicRelations = [
  tryOutTCForClient,
  {
    leftIcon: zoomInIcon,
    creationReason: findNewAgents,
    title: findNewClientsText,
    desc: [
      '- I want to find new clients that we can provide PR services to.',
    ],
  },
];

export const techProviders = [
  {
    leftIcon: supervisorIcon,
    creationReason: tryOutForClient,
    title: findNewSuppliersText,
    desc: [
      '- I want to find new supplier clients who can use our technology.',
    ],
  },
  {
    leftIcon: zoomInIcon,
    creationReason: findNewAgents,
    title: findNewAgentsText,
    desc: [
      '- I want to find new agent/buyer clients who can use our technology.',
    ],
  },
];

export const industryMemberOrganization = [
  {
    leftIcon: supervisorIcon,
    creationReason: tryOutForClient,
    title: 'Find New Supplier Members',
    desc: [
      '- I want to find new suppliers that may want to become members of our organization.',
    ],
  },
  {
    leftIcon: zoomInIcon,
    creationReason: findNewAgents,
    title: 'Find New Agent/Buyer Members',
    desc: [
      '- I want to find new agents/buyers that may want to become members of our organization.',
    ],
  },
  {
    leftIcon: connectionIcon,
    creationReason: connectWithPartners,
    title: 'Connect With Our Current Members',
    desc: [
      '- I want a better way to stay connected with our membership base.',
    ],
  },
];

export const mediaProvider = [
  {
    leftIcon: zoomInIcon,
    creationReason: tryOutForClient,
    title: 'Try Out TourConnect',
    desc: [
      '- I want to see how TourConnect helps other companies.',
    ],
  },
  {
    leftIcon: connectionIcon,
    creationReason: connectWithPartners,
    title: 'Connect With Other Companies',
    desc: [
      '- I want to connect with other TourConnect members.',
    ],
  },
];


export const otherProvider = [
  {
    leftIcon: supervisorIcon,
    creationReason: tryOutForClient,
    title: 'Find New Supplier Members',
    desc: [
      '- I want to find new supplier clients.',
    ],
  },
  {
    leftIcon: zoomInIcon,
    creationReason: findNewAgents,
    title: 'Connect With Our Current Members',
    desc: [
      '- I want to find new agent/buyer clients.',
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/components/signup/acct-creation-reason/acct-creation-text.jsx